import { marketPlace as axios } from "../../config/axios";
import {
  PRODUCT_LIST_FAILED,
  PRODUCT_LIST_SUCCESS,
  PRODUCT_LIST_INVALID_REQUEST,
  PRODUCT_LIST_NOT_FOUND,
  LOADING_PRODUCT_LIST,
  RESET_PRODUCT_LIST,
  ADDRESS_LIST_FAILED,
  ADDRESS_LIST_SUCCESS,
  ADDRESS_LIST_INVALID_REQUEST,
  ADDRESS_LIST_NOT_FOUND,
  LOADING_ADDRESS_LIST,
  RESET_ADDRESS_LIST,
  SAVE_ADDRESS_FAILED,
  SAVE_ADDRESS_INVALID_REQUEST,
  SAVE_ADDRESS_SUCCESS,
  LOADING_SAVE_ADDRESS,
  RESET_SAVE_ADDRESS,
  DELETE_ADDRESS_FAILED,
  DELETE_ADDRESS_INVALID_REQUEST,
  DELETE_ADDRESS_SUCCESS,
  DELETE_ADDRESS_NOT_FOUND,
  LOADING_DELETE_ADDRESS,
  RESET_DELETE_ADDRESS,
  ADD_PRODUCT_FAILED,
  ADD_PRODUCT_SUCCESS,
  RESET_ADD_PRODUCT,
  LOADING_ADD_PRODUCT,
  ADD_PRODUCT_INVALID_REQUEST,
  REMOVE_PRODUCT_FAILED,
  REMOVE_PRODUCT_SUCCESS,
  RESET_REMOVE_PRODUCT,
  LOADING_REMOVE_PRODUCT,
  REMOVE_PRODUCT_INVALID_REQUEST,
  CART_LIST_FAILED,
  CART_LIST_SUCCESS,
  CART_LIST_INVALID_REQUEST,
  CART_LIST_NOT_FOUND,
  LOADING_CART_LIST,
  RESET_CART_LIST,
  MP_CATEGORIES_FAILED,
  MP_CATEGORIES_SUCCESS,
  MP_CATEGORIES_INVALID_REQUEST,
  MP_CATEGORIES_NOT_FOUND,
  LOADING_MP_CATEGORIES,
  RESET_MP_CATEGORIES,
  BUY_PRODUCT_NOT_FOUND,
  BUY_PRODUCT_INVALID_REQUEST,
  BUY_PRODUCT_INVALID_TYPE,
  BUY_PRODUCT_FAILED,
  BUY_PRODUCT_SUCCESS,
  BUY_PRODUCT_OPERATION_NOT_PERMITTED,
  LOADING_BUY_PRODUCT,
  RESET_BUY_PRODUCT,
  BUY_NOW_PRODUCT,
  RESET_BUYNOW_PRODUCT,
  PROMO_CODE_FAILED,
  PROMO_CODE_INVALID_REQUEST,
  PROMO_CODE_NOT_FOUND,
  PROMO_CODE_SUCCESS,
  LOADING_PROMO_CODE,
  RESET_PROMO_CODE,
  DELIVERY_ADDRESS,
  VENDOR_PRODUCTS_FAILED,
  VENDOR_PRODUCTS_INVALID_REQUEST,
  VENDOR_PRODUCTS_NOT_FOUND,
  VENDOR_PRODUCTS_SUCCESS,
  LOADING_VENDOR_PRODUCTS,
  RESET_VENDOR_PRODUCTS,
  DELETE_VP_FAILED,
  DELETE_VP_INVALID_REQUEST,
  DELETE_VP_NOT_FOUND,
  DELETE_VP_SUCCESS,
  LOADING_DELETE_VP,
  RESET_DELETE_VP,
  UPLOAD_PRODUCT_FAILED,
  UPLOAD_PRODUCT_SUCCESS,
  UPLOAD_PRODUCT_INVALID_REQUEST,
  UPLOAD_PRODUCT_NOT_FOUND,
  LOADING_UPLOAD_PRODUCT,
  RESET_UPLOAD_PRODUCT,
  EDIT_VENDOR_PRODUCT,
  RESET_EDIT_VENDOR_PRODUCT,
  RESET_ORDERS_LIST,
  ORDERS_LIST_NOT_FOUND,
  ORDERS_LIST_FAILED,
  ORDERS_LIST_INVALID_REQUEST,
  ORDERS_LIST_SUCCESS,
  LOADING_ORDERS_LIST,
  ORDERS_SELL_REPORT_FAILED,
  ORDERS_SELL_REPORT_INVALID_REQUEST,
  ORDERS_SELL_REPORT_NOT_FOUND,
  ORDERS_SELL_REPORT_SUCCESS,
  LOADING_ORDERS_SELL_REPORT,
  RESET_ORDERS_SELL_REPORT,
  RESET_CHANGE_STATUS,
  CHANGE_STATUS_NOT_FOUND,
  CHANGE_STATUS_FAILED,
  CHANGE_STATUS_INVALID_REQUEST,
  CHANGE_STATUS_SUCCESS,
  LOADING_CHANGE_STATUS,
  RESET_MY_ORDERS,
  MY_ORDERS_NOT_FOUND,
  MY_ORDERS_FAILED,
  MY_ORDERS_INVALID_REQUEST,
  MY_ORDERS_SUCCESS,
  LOADING_MY_ORDERS,
  RESET_CANCEL_PURORDER,
  CANCEL_PURORDER_NOT_FOUND,
  CANCEL_PURORDER_FAILED,
  CANCEL_PURORDER_INVALID_REQUEST,
  CANCEL_PURORDER_SUCCESS,
  LOADING_CANCEL_PURORDER,
} from "../types";

const buyNowProduct = (p) => {
  return {
    type: BUY_NOW_PRODUCT,
    payload: p,
  };
};

const deliveryAddress = (addr) => {
  return {
    type: DELIVERY_ADDRESS,
    payload: addr,
  };
};

const editVendorProduct = (product) => {
  return {
    type: EDIT_VENDOR_PRODUCT,
    payload: product,
  };
};

const resetEditVendorProduct = () => ({ type: RESET_EDIT_VENDOR_PRODUCT });

const resetBuyNowProduct = () => {
  return {
    type: RESET_BUYNOW_PRODUCT,
  };
};

const resetMarketPlaceCategories = () => {
  return {
    type: RESET_MP_CATEGORIES,
  };
};

const getMarketPlaceCategories = (userData) => (dispatch) => {
  dispatch(mPCLoading());

  axios
    .post("MerchantServices/getCategories", userData)
    .then((res) => {
      switch (res.data.responseCode) {
        case "1":
          dispatch(mPCSuccess(res.data));
          break;

        case "2":
          dispatch(mPCFailed(res.data));
          break;

        case "3":
          dispatch(mPCInvalidRequest(res.data));
          break;

        default:
          break;
      }
    })
    .catch((err) =>
      err.name === "TypeError"
        ? dispatch({ type: MP_CATEGORIES_NOT_FOUND })
        : ""
    );
};

function mPCLoading() {
  return {
    type: LOADING_MP_CATEGORIES,
  };
}

function mPCFailed(data) {
  return {
    type: MP_CATEGORIES_FAILED,
    payload: data,
  };
}

function mPCInvalidRequest(data) {
  return {
    type: MP_CATEGORIES_INVALID_REQUEST,
    payload: data,
  };
}

function mPCSuccess(data) {
  return {
    type: MP_CATEGORIES_SUCCESS,
    payload: data,
  };
}

const resetUploadProduct = () => {
  return {
    type: RESET_UPLOAD_PRODUCT,
  };
};

const uploadProduct = (userData, type) => (dispatch) => {
  dispatch(uPLoading());
  console.log(userData);
  axios
    .post(
      `MerchantServices/${
        type === "upload" ? "uploadProduct" : "updateProduct"
      }`,
      userData
    )
    .then((res) => {
      switch (res.data.responseCode) {
        case "1":
          dispatch(uPSuccess(res.data));
          break;

        case "2":
          dispatch(uPFailed(res.data));
          break;

        case "3":
          dispatch(uPInvalidRequest(res.data));
          break;

        default:
          dispatch(uPFailed(res.data));
          break;
      }
    })
    .catch((err) =>
      err.name === "TypeError"
        ? dispatch({ type: UPLOAD_PRODUCT_NOT_FOUND })
        : ""
    );
};

function uPLoading() {
  return {
    type: LOADING_UPLOAD_PRODUCT,
  };
}

function uPFailed(data) {
  return {
    type: UPLOAD_PRODUCT_FAILED,
    payload: data,
  };
}

function uPInvalidRequest(data) {
  return {
    type: UPLOAD_PRODUCT_INVALID_REQUEST,
    payload: data,
  };
}

function uPSuccess(data) {
  return {
    type: UPLOAD_PRODUCT_SUCCESS,
    payload: data,
  };
}

const resetOrdersList = () => {
  return {
    type: RESET_ORDERS_LIST,
  };
};

const getOrdersList = (userData) => (dispatch) => {
  dispatch(oLLoading());
  axios
    .post("MerchantServices/ordersList", userData)
    .then((res) => {
      switch (res.data.responseCode) {
        case "0":
          dispatch(oLSuccess(res.data));
          break;

        case "2":
          dispatch(oLFailed(res.data));
          break;

        case "3":
          dispatch(oLInvalidRequest(res.data));
          break;

        default:
          break;
      }
    })
    .catch((err) =>
      err.name === "TypeError" ? dispatch({ type: ORDERS_LIST_NOT_FOUND }) : ""
    );
};

function oLLoading() {
  return {
    type: LOADING_ORDERS_LIST,
  };
}

function oLFailed(data) {
  return {
    type: ORDERS_LIST_FAILED,
    payload: data,
  };
}

function oLInvalidRequest(data) {
  return {
    type: ORDERS_LIST_INVALID_REQUEST,
    payload: data,
  };
}

function oLSuccess(data) {
  return {
    type: ORDERS_LIST_SUCCESS,
    payload: data,
  };
}

const resetOSReport = () => {
  return {
    type: RESET_ORDERS_SELL_REPORT,
  };
};

const getOrdersSellReport = (userData) => (dispatch) => {
  dispatch(oSPLoading());
  axios
    .post("MerchantServices/ordersSellReport", userData)
    .then((res) => {
      const OrdersSellReportResponse = [].concat(
        res.data.OrdersSellReportResponse
      );

      dispatch(oSPSuccess(OrdersSellReportResponse));

      // switch (OrdersSellReportResponse[0].responseCode) {
      //   case "0":
      //     dispatch(oSPSuccess(res.data));
      //     break;

      //   case "2":
      //     dispatch(oSPFailed(res.data));
      //     break;

      //   case "3":
      //     dispatch(oSPInvalidRequest(res.data));
      //     break;

      //   default:
      //     break;
      // }
    })
    .catch((err) =>
      err.name === "TypeError"
        ? dispatch({ type: ORDERS_SELL_REPORT_NOT_FOUND })
        : ""
    );
};

function oSPLoading() {
  return {
    type: LOADING_ORDERS_SELL_REPORT,
  };
}

// function oSPFailed(data) {
//   return {
//     type: ORDERS_SELL_REPORT_FAILED,
//     payload: data,
//   };
// }

// function oSPInvalidRequest(data) {
//   return {
//     type: ORDERS_SELL_REPORT_INVALID_REQUEST,
//     payload: data,
//   };
// }

function oSPSuccess(data) {
  return {
    type: ORDERS_SELL_REPORT_SUCCESS,
    payload: data,
  };
}

const resetChangeOrderStatus = () => {
  return {
    type: RESET_CHANGE_STATUS,
  };
};

const changeOrerStatus = (userData) => (dispatch) => {
  dispatch(cSLoading());
  axios
    .post("MerchantServices/changeOrderStatus", userData)
    .then((res) => {
      switch (res.data.responseCode) {
        case "0":
          dispatch(cSSuccess(res.data));
          break;

        case "2":
          dispatch(cSFailed(res.data));
          break;

        case "3":
          dispatch(cSInvalidRequest(res.data));
          break;

        default:
          break;
      }
    })
    .catch((err) =>
      err.name === "TypeError"
        ? dispatch({ type: CHANGE_STATUS_NOT_FOUND })
        : ""
    );
};

function cSLoading() {
  return {
    type: LOADING_CHANGE_STATUS,
  };
}

function cSFailed(data) {
  return {
    type: CHANGE_STATUS_FAILED,
    payload: data,
  };
}

function cSInvalidRequest(data) {
  return {
    type: CHANGE_STATUS_INVALID_REQUEST,
    payload: data,
  };
}

function cSSuccess(data) {
  return {
    type: CHANGE_STATUS_SUCCESS,
    payload: data,
  };
}

const resetMyOrders = () => {
  return {
    type: RESET_MY_ORDERS,
  };
};

const getMyOrders = (userData) => (dispatch) => {
  dispatch(gMOLoading());
  axios
    .post("MerchantServices/customerOrderList", userData)
    .then((res) => {
      const MyOrderListResponse = [].concat(res.data.MyOrderListResponse);
      switch (MyOrderListResponse[0].responseCode) {
        case "0":
          dispatch(gMOSuccess(MyOrderListResponse));
          break;

        case "2":
          dispatch(gMOFailed(MyOrderListResponse));
          break;

        case "3":
          dispatch(gMOInvalidRequest(MyOrderListResponse));
          break;

        default:
          break;
      }
    })
    .catch((err) =>
      err.name === "TypeError" ? dispatch({ type: MY_ORDERS_NOT_FOUND }) : ""
    );
};

function gMOLoading() {
  return {
    type: LOADING_MY_ORDERS,
  };
}

function gMOFailed(data) {
  return {
    type: MY_ORDERS_FAILED,
    payload: data,
  };
}

function gMOInvalidRequest(data) {
  return {
    type: MY_ORDERS_INVALID_REQUEST,
    payload: data,
  };
}

function gMOSuccess(data) {
  return {
    type: MY_ORDERS_SUCCESS,
    payload: data,
  };
}

// const resetChangeOrderStatus = () => {
//   return {
//     type: RESET_CHANGE_STATUS,
//   };
// };

// const changeOrerStatus = (userData) => (dispatch) => {
//   dispatch(cSLoading());
//   axios
//     .post("MerchantServices/changeOrderStatus", userData)
//     .then((res) => {
//       switch (res.data.responseCode) {
//         case "0":
//           dispatch(cSSuccess(res.data));
//           break;

//         case "2":
//           dispatch(cSFailed(res.data));
//           break;

//         case "3":
//           dispatch(cSInvalidRequest(res.data));
//           break;

//         default:
//           break;
//       }
//     })
//     .catch((err) =>
//       err.name === "TypeError"
//         ? dispatch({ type: CHANGE_STATUS_NOT_FOUND })
//         : ""
//     );
// };

// function cSLoading() {
//   return {
//     type: LOADING_CHANGE_STATUS,
//   };
// }

// function cSFailed(data) {
//   return {
//     type: CHANGE_STATUS_FAILED,
//     payload: data,
//   };
// }

// function cSInvalidRequest(data) {
//   return {
//     type: CHANGE_STATUS_INVALID_REQUEST,
//     payload: data,
//   };
// }

// function cSSuccess(data) {
//   return {
//     type: CHANGE_STATUS_SUCCESS,
//     payload: data,
//   };
// }

const resetCancelPurchasedOrder = () => {
  return {
    type: RESET_CANCEL_PURORDER,
  };
};

const resetProductList = () => {
  return {
    type: RESET_PRODUCT_LIST,
  };
};

const getProductList = (userData) => (dispatch) => {
  const { ccId } = userData;
  dispatch(pLLoading());

  axios
    .post("ProductServices/productList", userData)
    .then((res) => {
      const ListOfProductsResponse = [].concat(res.data.ListOfProductsResponse);
      switch (ListOfProductsResponse[0].responseCode) {
        case "0":
          dispatch(pLSuccess(ListOfProductsResponse, ccId));
          break;

        case "2":
          dispatch(pLFailed(ListOfProductsResponse));
          break;

        case "3":
          dispatch(pLInvalidRequest());
          break;

        default:
          break;
      }
    })
    .catch((err) =>
      err.name === "TypeError" ? dispatch({ type: PRODUCT_LIST_NOT_FOUND }) : ""
    );
};

function pLLoading() {
  return {
    type: LOADING_PRODUCT_LIST,
  };
}

function pLFailed(data) {
  return {
    type: PRODUCT_LIST_FAILED,
    payload: data,
  };
}

function pLInvalidRequest(data) {
  return {
    type: PRODUCT_LIST_INVALID_REQUEST,
    payload: data,
  };
}

function pLSuccess(data, ccId) {
  return {
    type: PRODUCT_LIST_SUCCESS,
    payload: { data, ccId },
  };
}

const resetGetCartList = () => {
  return {
    type: RESET_CART_LIST,
  };
};

const getCartList = (userData) => (dispatch) => {
  dispatch(gCLoading());

  axios
    .post("ProductServices/listCartOffers", userData)
    .then((res) => {
      const CartOffersResponse = [].concat(res.data.CartOffersResponse);
      switch (CartOffersResponse[0].responseCode) {
        case "0":
          dispatch(gCSuccess(CartOffersResponse));
          break;

        case "2":
          dispatch(gCFailed(CartOffersResponse));
          break;

        case "3":
          dispatch(gCInvalidRequest());
          break;

        default:
          break;
      }
    })
    .catch((err) =>
      err.name === "TypeError" ? dispatch({ type: CART_LIST_NOT_FOUND }) : ""
    );
};

function gCLoading() {
  return {
    type: LOADING_CART_LIST,
  };
}

function gCFailed(data) {
  return {
    type: CART_LIST_FAILED,
    payload: data,
  };
}

function gCInvalidRequest(data) {
  return {
    type: CART_LIST_INVALID_REQUEST,
    payload: data,
  };
}

function gCSuccess(data) {
  return {
    type: CART_LIST_SUCCESS,
    payload: data,
  };
}

const resetAddProduct = () => {
  return {
    type: RESET_ADD_PRODUCT,
  };
};

const addProductCart = (userData) => (dispatch) => {
  dispatch(aPLoading());

  axios
    .post("ProductServices/addProductCart", userData)
    .then((res) => {
      switch (res.data.responseCode) {
        case "0":
          dispatch(aPSuccess(res.data));
          break;

        case "2":
          dispatch(aPFailed(res.data));
          break;

        case "3":
          dispatch(aPInvalidRequest(res.data));
          break;

        default:
          break;
      }
    })
    .catch((err) =>
      err.name === "TypeError" ? dispatch({ type: PRODUCT_LIST_NOT_FOUND }) : ""
    );
};

function aPLoading() {
  return {
    type: LOADING_ADD_PRODUCT,
  };
}

function aPFailed(data) {
  return {
    type: ADD_PRODUCT_FAILED,
    payload: data,
  };
}

function aPInvalidRequest(data) {
  return {
    type: ADD_PRODUCT_INVALID_REQUEST,
    payload: data,
  };
}

function aPSuccess(data) {
  return {
    type: ADD_PRODUCT_SUCCESS,
    payload: data,
  };
}

const resetRemoveProduct = () => {
  return {
    type: RESET_REMOVE_PRODUCT,
  };
};

const removeProductCart = (userData, price) => (dispatch) => {
  dispatch(rPLoading());

  axios
    .post("ProductServices/removeProductFromCart", userData)
    .then((res) => {
      switch (res.data.responseCode) {
        case "0":
          dispatch(rPSuccess(res.data, price));
          break;

        case "2":
          dispatch(rPFailed(res.data));
          break;

        case "3":
          dispatch(rPInvalidRequest(res.data));
          break;

        default:
          break;
      }
    })
    .catch((err) =>
      err.name === "TypeError" ? dispatch({ type: PRODUCT_LIST_NOT_FOUND }) : ""
    );
};

function rPLoading() {
  return {
    type: LOADING_REMOVE_PRODUCT,
  };
}

function rPFailed(data) {
  return {
    type: REMOVE_PRODUCT_FAILED,
    payload: data,
  };
}

function rPInvalidRequest(data) {
  return {
    type: REMOVE_PRODUCT_INVALID_REQUEST,
    payload: data,
  };
}

function rPSuccess(data, price) {
  return {
    type: REMOVE_PRODUCT_SUCCESS,
    payload: { data, price },
  };
}

const resetBuyProduct = () => {
  return {
    type: RESET_BUY_PRODUCT,
  };
};

const buyProduct = (userData, price) => (dispatch) => {
  dispatch(bPLoading());

  axios
    .post("ProductServices/productPurchase", userData)
    .then((res) => {
      switch (res.data.responseCode) {
        case "0":
          dispatch(bPFailed(res.data));
          break;

        case "1":
          dispatch(bPSuccess(res.data, price));
          break;

        case "2":
          dispatch(bPFailed(res.data));
          break;

        case "3":
          dispatch(bPInvalidRequest(res.data));
          break;

        case "53":
          dispatch(bPInvalidType(res.data));
          break;

        case "61":
          dispatch(bPOperationNotPermitted(res.data));
          break;

        default:
          break;
      }
    })
    .catch((err) =>
      err.name === "TypeError" ? dispatch({ type: BUY_PRODUCT_NOT_FOUND }) : ""
    );
};

function bPLoading() {
  return {
    type: LOADING_BUY_PRODUCT,
  };
}

function bPFailed(data) {
  return {
    type: BUY_PRODUCT_FAILED,
    payload: data,
  };
}

function bPInvalidRequest(data) {
  return {
    type: BUY_PRODUCT_INVALID_REQUEST,
    payload: data,
  };
}

function bPInvalidType(data) {
  return {
    type: BUY_PRODUCT_INVALID_TYPE,
    payload: data,
  };
}

function bPSuccess(data) {
  return {
    type: BUY_PRODUCT_SUCCESS,
    payload: data,
  };
}

function bPOperationNotPermitted(data) {
  return {
    type: BUY_PRODUCT_OPERATION_NOT_PERMITTED,
    payload: data,
  };
}

const resetPromoCode = () => {
  return {
    type: RESET_PROMO_CODE,
  };
};

const getPromoCodesList = (userData) => (dispatch) => {
  dispatch(pCLoading());

  axios
    .post("ProductServices/promoCodeList", userData)
    .then((res) => {
      const PromoCodeResponse = [].concat(res.data.PromoCodeResponse);
      switch (PromoCodeResponse[0].responseCode) {
        case "0":
          dispatch(pCSuccess(PromoCodeResponse));
          break;

        case "2":
          dispatch(pCFailed(PromoCodeResponse));
          break;

        case "3":
          dispatch(pCInvalidRequest(PromoCodeResponse));
          break;

        default:
          break;
      }
    })
    .catch((err) =>
      err.name === "TypeError" ? dispatch({ type: PROMO_CODE_NOT_FOUND }) : ""
    );
};

function pCLoading() {
  return {
    type: LOADING_PROMO_CODE,
  };
}

function pCFailed(data) {
  return {
    type: PROMO_CODE_FAILED,
    payload: data,
  };
}

function pCInvalidRequest(data) {
  return {
    type: PROMO_CODE_INVALID_REQUEST,
    payload: data,
  };
}

function pCSuccess(data) {
  return {
    type: PROMO_CODE_SUCCESS,
    payload: data,
  };
}

const resetVendorProductsList = () => {
  return {
    type: RESET_VENDOR_PRODUCTS,
  };
};

const getVendorProductsList = (userData) => (dispatch) => {
  dispatch(vPLoading());

  axios
    .post("ProductServices/vendorProducts", userData)
    .then((res) => {
      const VendorProductsResponse = [].concat(res.data.VendorProductsResponse);
      switch (VendorProductsResponse[0].responseCode) {
        case "0":
          dispatch(vPSuccess(VendorProductsResponse));
          break;

        case "2":
          dispatch(vPFailed(VendorProductsResponse));
          break;

        case "3":
          dispatch(vPInvalidRequest(VendorProductsResponse));
          break;

        default:
          break;
      }
    })
    .catch((err) =>
      err.name === "TypeError"
        ? dispatch({ type: VENDOR_PRODUCTS_NOT_FOUND })
        : ""
    );
};

function vPLoading() {
  return {
    type: LOADING_VENDOR_PRODUCTS,
  };
}

function vPFailed(data) {
  return {
    type: VENDOR_PRODUCTS_FAILED,
    payload: data,
  };
}

function vPInvalidRequest(data) {
  return {
    type: VENDOR_PRODUCTS_INVALID_REQUEST,
    payload: data,
  };
}

function vPSuccess(data) {
  return {
    type: VENDOR_PRODUCTS_SUCCESS,
    payload: data,
  };
}

const resetDeleteVP = () => {
  return {
    type: RESET_DELETE_VP,
  };
};

const removeVendorProduct = (userData, productId) => (dispatch) => {
  dispatch(rVPLoading());

  axios
    .post("ProductServices/deleteVendorProduct", userData)
    .then((res) => {
      switch (res.data.responseCode) {
        case "1":
          dispatch(rVPSuccess(res.data, productId));
          break;

        case "2":
          dispatch(rVPFailed(res.data));
          break;

        case "3":
          dispatch(rVPInvalidRequest(res.data));
          break;

        default:
          break;
      }
    })
    .catch((err) =>
      err.name === "TypeError" ? dispatch({ type: DELETE_VP_NOT_FOUND }) : ""
    );
};

function rVPLoading() {
  return {
    type: LOADING_DELETE_VP,
  };
}

function rVPFailed(data) {
  return {
    type: DELETE_VP_FAILED,
    payload: data,
  };
}

function rVPInvalidRequest(data) {
  return {
    type: DELETE_VP_INVALID_REQUEST,
    payload: data,
  };
}

function rVPSuccess(data, productId) {
  return {
    type: DELETE_VP_SUCCESS,
    payload: { data, productId },
  };
}

const resetAddressList = () => {
  return {
    type: RESET_ADDRESS_LIST,
  };
};

const getAddressList = (userData) => (dispatch) => {
  dispatch(gALoading());

  axios
    .post("ProductServices/listOfAddress", userData)
    .then((res) => {
      const CustomerAddressResponse = [].concat(
        res.data.CustomerAddressResponse
      );
      switch (CustomerAddressResponse[0].responseCode) {
        case "0":
          dispatch(gASuccess(CustomerAddressResponse));
          break;

        case "2":
          dispatch(gAFailed(CustomerAddressResponse));
          break;

        case "3":
          dispatch(gAInvalidRequest());
          break;

        default:
          break;
      }
    })
    .catch((err) =>
      err.name === "TypeError" ? dispatch({ type: ADDRESS_LIST_NOT_FOUND }) : ""
    );
};

function gALoading() {
  return {
    type: LOADING_ADDRESS_LIST,
  };
}

function gAFailed(data) {
  return {
    type: ADDRESS_LIST_FAILED,
    payload: data,
  };
}

function gAInvalidRequest(data) {
  return {
    type: ADDRESS_LIST_INVALID_REQUEST,
    payload: data,
  };
}

function gASuccess(data) {
  return {
    type: ADDRESS_LIST_SUCCESS,
    payload: data,
  };
}

const resetSaveAddress = () => {
  return {
    type: RESET_SAVE_ADDRESS,
  };
};

const saveAddress = (userData) => (dispatch) => {
  dispatch(sALoading());

  axios
    .post("ProductServices/saveAddress", userData)
    .then((res) => {
      switch (res.data.responseCode) {
        case "1":
          dispatch(sASuccess(res.data));
          break;

        case "2":
          dispatch(sAFailed(res.data));
          break;

        case "3":
          dispatch(sAInvalidRequest(res.data));
          break;

        default:
          break;
      }
    })
    .catch((err) =>
      err.name === "TypeError" ? dispatch({ type: ADDRESS_LIST_NOT_FOUND }) : ""
    );
};

function sALoading() {
  return {
    type: LOADING_SAVE_ADDRESS,
  };
}

function sAFailed(data) {
  return {
    type: SAVE_ADDRESS_FAILED,
    payload: data,
  };
}

function sAInvalidRequest(data) {
  return {
    type: SAVE_ADDRESS_INVALID_REQUEST,
    payload: data,
  };
}

function sASuccess(data) {
  return {
    type: SAVE_ADDRESS_SUCCESS,
    payload: data,
  };
}

const resetDeleteAddress = () => {
  return {
    type: RESET_DELETE_ADDRESS,
  };
};

const deleteAddress = (userData) => (dispatch) => {
  const { addrId } = userData;
  dispatch(dALoading());

  axios
    .post("ProductServices/deleteAddress", userData)
    .then((res) => {
      switch (res.data.responseCode) {
        case "1":
          dispatch(dASuccess(res.data, addrId));
          break;

        case "2":
          dispatch(dAFailed(res.data));
          break;

        case "3":
          dispatch(dAInvalidRequest(res.data));
          break;

        default:
          break;
      }
    })
    .catch((err) =>
      err.name === "TypeError"
        ? dispatch({ type: DELETE_ADDRESS_NOT_FOUND })
        : ""
    );
};

function dALoading() {
  return {
    type: LOADING_DELETE_ADDRESS,
  };
}

function dAFailed(data) {
  return {
    type: DELETE_ADDRESS_FAILED,
    payload: data,
  };
}

function dAInvalidRequest(data) {
  return {
    type: DELETE_ADDRESS_INVALID_REQUEST,
    payload: data,
  };
}

function dASuccess(data, addrId) {
  return {
    type: DELETE_ADDRESS_SUCCESS,
    payload: { data, addrId },
  };
}

const cancelPurchasedOrder = (userData) => (dispatch) => {
  dispatch(cPOLoading());
  axios
    .post("ProductServices/cancelPurchasedOrder", userData)
    .then((res) => {
      switch (res.data.responseCode) {
        case "1":
          dispatch(cPOSuccess(res.data));
          break;

        case "2":
          dispatch(cPOFailed(res.data));
          break;

        case "3":
          dispatch(cPOInvalidRequest(res.data));
          break;

        default:
          break;
      }
    })
    .catch((err) =>
      err.name === "TypeError"
        ? dispatch({ type: CANCEL_PURORDER_NOT_FOUND })
        : ""
    );
};

function cPOLoading() {
  return {
    type: LOADING_CANCEL_PURORDER,
  };
}

function cPOFailed(data) {
  return {
    type: CANCEL_PURORDER_FAILED,
    payload: data,
  };
}

function cPOInvalidRequest(data) {
  return {
    type: CANCEL_PURORDER_INVALID_REQUEST,
    payload: data,
  };
}

function cPOSuccess(data) {
  return {
    type: CANCEL_PURORDER_SUCCESS,
    payload: data,
  };
}

export {
  resetCancelPurchasedOrder,
  cancelPurchasedOrder,
  resetMyOrders,
  getMyOrders,
  resetProductList,
  getProductList,
  resetAddressList,
  getAddressList,
  resetSaveAddress,
  saveAddress,
  resetAddProduct,
  addProductCart,
  getCartList,
  resetGetCartList,
  getMarketPlaceCategories,
  resetMarketPlaceCategories,
  resetRemoveProduct,
  removeProductCart,
  resetDeleteAddress,
  deleteAddress,
  resetBuyProduct,
  buyProduct,
  buyNowProduct,
  resetBuyNowProduct,
  resetPromoCode,
  getPromoCodesList,
  deliveryAddress,
  getVendorProductsList,
  resetVendorProductsList,
  resetDeleteVP,
  removeVendorProduct,
  resetUploadProduct,
  uploadProduct,
  editVendorProduct,
  resetEditVendorProduct,
  getOrdersList,
  resetOrdersList,
  resetOSReport,
  getOrdersSellReport,
  resetChangeOrderStatus,
  changeOrerStatus,
};
